import React from 'react';
import ReadingAidButton from '../../platformui/ReadingAid/reading-aid-button';

const ReadingAidDynamic = (props) => {
  return (
    <div className="reading-aid-block">
      <div className="reading-aid-block__content">
        {props.ReadingAidText && (
          <div className="reading-aid-block__text">
            <p>{props.ReadingAidText}</p>
          </div>
        )}
        {props.CurrentPageProps && props.CurrentPageProps.ReadingAid && (
          <div className="reading-aid-block__button-wrapper">
            <ReadingAidButton ReadingAid={props.CurrentPageProps.ReadingAid} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReadingAidDynamic;
